import ParseQueryParams from "@core/helper/ParseQueryParams";
import Client from "./client";

const baseUrl = `/api/1/ohlcvs`;

function ohlcvs() {
  return {
    getStats: () => {
      return Client.getWithoutLoading(baseUrl + `/stats`);
    },
    getOhlcv: (params) => {
      return Client.getWithoutLoading(baseUrl, params);
    },
    getOhlcvTV: (queryparams) => {
      return Client.getWithoutLoading(
        baseUrl + `/tradingView?${ParseQueryParams(queryparams)}`
      );
    },
  };
}

export default ohlcvs();
